<template>
  <SimpleLoadingChartContainer
    :chartOptions="robChartOptions"
    :loading="fetchFuelConsumptionDataLoading"
    loadingText="Loading ROB Chart..."
  >
    <template #header>
      <span class="rob-chart-title">Rob</span>
    </template>
  </SimpleLoadingChartContainer>
</template>
    
    
    <script>
import { mapGetters, mapState } from "vuex";
import SimpleLoadingChartContainer from "../../../../core/SimpleLoadingChartContainer.vue";
export default {
  name: "RobChart",
  components: {
    SimpleLoadingChartContainer,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters("vesselInformation/voyageFuelConsumptionDataModule", [
      "robChartOptions",
    ]),
    ...mapState("vesselInformation/voyageFuelConsumptionDataModule", [
      "fetchFuelConsumptionDataLoading",
    ]),
  },
};
</script>

<style scoped>
.rob-chart-title {
  font-size: 18px;
  font-weight: bold;
  color: var(--color-text);
}
</style>
